import React from 'react'
import { Link } from "react-router-dom";
import OurTeam from '../home/OurTeam';


const Faculty = () => {
    return (
        <>

            <div className="site-breadcrumb" style={{ background: 'url(assets/school/about.webp)' }}>
                <div className="container">
                    <h2 className="breadcrumb-title">Faculty</h2>
                    <ul className="breadcrumb-menu">
                        <li><Link to="/">Home</Link></li>
                        <li className="active" style={{ color: "red" }}>Faculty</li>
                    </ul>
                </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <OurTeam />
        </>
    )
}

export default Faculty